export default __webpack_public_path__ + "static/media/search.5b905028.svg";